import React from "react";

const ManufacturerIcon = ({ size = 12, color = "none", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 13"
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49994 7.5V9.3C7.49994 9.72005 7.49994 9.93005 7.41819 10.0905C7.34629 10.2316 7.23154 10.3463 7.09044 10.4182C6.92999 10.5 6.71999 10.5 6.29994 10.5H3.69994C3.27991 10.5 3.06989 10.5 2.90945 10.4182C2.76833 10.3463 2.65359 10.2316 2.58169 10.0905C2.49994 9.93005 2.49994 9.72005 2.49994 9.3V5.5M9.49994 5.5V10.5M2.49994 8.5H7.49994M2.77883 2.94223L1.78939 4.92111C1.69355 5.11279 1.64563 5.20863 1.65714 5.28654C1.66719 5.35457 1.70482 5.41545 1.76117 5.45486C1.8257 5.5 1.93285 5.5 2.14716 5.5H9.85274C10.067 5.5 10.1742 5.5 10.2387 5.45486C10.2951 5.41545 10.3327 5.35457 10.3427 5.28654C10.3542 5.20863 10.3063 5.11279 10.2105 4.92111L9.22104 2.94223C9.14079 2.7817 9.10064 2.70144 9.04079 2.64279C8.98784 2.59094 8.92404 2.55149 8.85399 2.52732C8.77474 2.5 8.68499 2.5 8.50554 2.5H3.49437C3.31489 2.5 3.22515 2.5 3.14593 2.52732C3.07586 2.55149 3.01205 2.59094 2.9591 2.64279C2.89923 2.70144 2.8591 2.7817 2.77883 2.94223Z"
      stroke="currentColor"
      stroke-width="0.9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default ManufacturerIcon;
